export const layerZeroEndpointByChainId = {
  '1': '0x66A71Dcef29A0fFBDBE3c6a460a3B5BC225Cd675', // ethereum
  '56': '0x3c2269811836af69497E5F486A85D7316753cf62', // bsc
  '5': '0xbfD2135BFfbb0B5378b56643c2Df8a87552Bfa23', // goerli
  '97': '0x6Fcb97553D41516Cb228ac03FdC8B9a0a9df04A1', // bsc testnet
  '11155111': '0xae92d5aD7583AD66E49A0c67BAd18F6ba52dDDc1', // sepolia testnet
};
